"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.separatorHandlerDefaultOptions = void 0;
var digits_separator_1 = require("./digits-separator");
exports.separatorHandlerDefaultOptions = {
    separator: ',',
};
exports.default = digits_separator_1.separateDigitsBySeparator;
